import { CustomerConverter } from 'converters/customer-converter';
import { PaytronixApiError } from 'store/api/errors';

const ACCOUNT_QUERY_API_ENDPOINT_PATH = '/transaction/accountQuery.json';

function buildAccountQueryRequest(posContext, accountQueries) {
  const headerInfo = {
    merchantId: Number(posContext.configurations.merchantId),
    storeCode: posContext.configurations.storeCode,
    operatorId: posContext.employee.id ?? '0',
    terminalId: posContext.device.id ?? '0',
    senderId: 'POS',
    programId: 'PX',
  };

  return {
    headerInfo,
    accountQueries,
    pageSize: 50,
  };
}

function buildAccountQueryResponse(responseFromApi) {
  const customers = responseFromApi.rows.map((row) => {
    return CustomerConverter.convert(responseFromApi.header.fields, row.fields);
  });

  return {
    responseCode: responseFromApi.responseCode,
    responseMessage: responseFromApi.responseMessage,
    customers,
  };
}

export async function queryAccounts(posContext, pxContext, accountQueries) {
  const request = buildAccountQueryRequest(posContext, accountQueries);
  const paytronixDomain = posContext.configurations.environmentUrl;

  const response = await fetch(
    `${paytronixDomain}${ACCOUNT_QUERY_API_ENDPOINT_PATH}`,
    {
      body: JSON.stringify(request),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${pxContext.authorizationToken}`,
      },
    }
  ).then((result) => result.json());

  if (response.result !== 'authorizedSuccess') {
    throw new PaytronixApiError({
      code: response.errorCode,
      message: response.errorMessage,
    });
  }

  return buildAccountQueryResponse(response);
}
